/**
 * Application logger.
 *
 * Levels:      error > warn > info > debug
 * Production:  error + warn only
 * Dev/test:    all levels
 *
 * Sensitive data:
 *   Wrap values with logger.sensitive(value) at call sites.
 *   In production the value is replaced with '[REDACTED]'.
 *   In dev/test the real value is passed through.
 *
 * Usage:
 *   import logger from '@/app/logger';
 *
 *   logger.debug('token refreshed');
 *   logger.warn('grid anchor ignored');
 *   logger.error('failed to load', err);
 *   logger.info('user loaded', logger.sensitive(user));
 */

const isProd = process.env.NODE_ENV === 'production';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const logger = {
    /** Redacts a value in production, passes it through in dev/test. */
    sensitive: (value: unknown): string | unknown => (isProd ? '[REDACTED]' : value),

    error: (...args: unknown[]) => console.error(...args),
    warn: (...args: unknown[]) => console.warn(...args),
    info: isProd ? noop : (...args: unknown[]) => console.info(...args),
    debug: isProd ? noop : (...args: unknown[]) => console.debug(...args),
};

export default logger;
